
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsCashCouponTypeSerialGrid extends Serenity.EntityGrid<PsCashCouponTypeSerialRow, any> {
        protected getColumnsKey() { return PsCashCouponTypeSerialColumns.columnsKey; }
        protected getDialogType() { return PsCashCouponTypeSerialDialog; }
        protected getIdProperty() { return PsCashCouponTypeSerialRow.idProperty; }
        protected getInsertPermission() { return PsCashCouponTypeSerialRow.insertPermission; }
        protected getLocalTextPrefix() { return PsCashCouponTypeSerialRow.localTextPrefix; }
        protected getService() { return PsCashCouponTypeSerialService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}